import React, {useState, useEffect} from 'react';

import {
    Grid,
    makeStyles,
    Button,
    Card,
    Typography
} from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { useOktaAuth } from "@okta/okta-react";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: "3%",
        minHeight: "90vh",
        marginBottom: '10%'
    },
    pageHeader: {
        fontSize: "2.5em",
        fontWeight: "bold"
    },
    sectionHeader: {
        fontWeight: "bold",
        fontSize: "1.5em"
    }
}));

export default function AdminHome(props){

    const classes = useStyles();

    const [redirectUrl, setRedirectUrl] = useState("/");
    const [redirect, setRedirect] = useState(false);
    const [admins, setAdmins] = useState([]);
    const { authState, oktaAuth } = useOktaAuth();
    const currUser = authState?.accessToken?.claims;

    const GET_ALL_ADMINS_ENDPOINT = '/system/admins';

    useEffect(() => {
      axios.get('/api' + GET_ALL_ADMINS_ENDPOINT, { headers: { 'Authorization': 'Bearer ' + authState.accessToken.accessToken }, })
        .then((res) => {
          if (res.status === 200) {
            setAdmins(res.data);
          }
        })
        .catch((err) => console.error(err));
    },[]);

    const handleAddAdminClick = () => {
        setRedirectUrl("/admin/addAdminFromEmail");
        setRedirect(true);
    }

    const handleEditContactClick = () => {
        setRedirectUrl("/admin/editContact");
        setRedirect(true);
    }

    const handleAddTeamPrimaryClick = () => {
        setRedirectUrl("/admin/addTeamAndPrimaryContact");
        setRedirect(true);
    }

    const handleAddNewFeaturesClick = () => {
        setRedirectUrl("/admin/newFeatures");
        setRedirect(true);
    }

    const handleFileUploadClick = () => {
        setRedirectUrl("/admin/fileUpload");
        setRedirect(true);
    }

    const listAllAdmins = () => {
      return admins.map((user) => {
        return (
          <Card style={{margin: 10, padding: 10}}>
            <Typography variant="h5" style={{fontWeight: "bold"}}>
              {user.displayName}
            </Typography>
            <Typography>Email: {user.email}</Typography>
            <Typography>UID: {user.uid}</Typography>
            <Typography>Company: {user.adminCompany}</Typography>
            <Typography>Role: {user.role}</Typography>
          </Card>
        );
      });
    }

    return(
        <>
        {redirect && <Redirect push to={redirectUrl} />}
        <Grid container spacing={2} justify="space-evenly">
          <Grid item>
            <Grid container className={classes.root} direction='column' spacing={7}>
                <Grid item>
                    <Typography className={classes.pageHeader}>
                        Admin Home
                    </Typography>
                </Grid>
                <Grid item container direction='column' spacing={2}>
                    <Grid item>
                        <Typography className={classes.sectionHeader}>Add admin</Typography>
                    </Grid>
                    <Grid item>
                        <Typography>Add an already registered user as an admin of the portal</Typography>
                    </Grid>
                    <Grid item>
                        <Button onClick={handleAddAdminClick}
                        color='primary'
                        variant='contained'
                        >
                            Add admin page
                        </Button>
                    </Grid>
                </Grid>
                <Grid item container direction='column' spacing={2}>
                    <Grid item>
                        <Typography className={classes.sectionHeader}>Edit Contact Team and Company</Typography>
                    </Grid>
                    <Grid item>
                        <Typography>Change the company or team of an already existing user</Typography>
                    </Grid>
                    <Grid item>
                        <Button onClick={handleEditContactClick}
                        color='primary'
                        variant='contained'
                        >
                            Edit team page
                        </Button>
                    </Grid>
                </Grid>
                <Grid item container direction='column' spacing={2}>
                    <Grid item>
                        <Typography className={classes.sectionHeader}>Add new Team and Primary Contact</Typography>
                    </Grid>
                    <Grid item>
                        <Typography>Add a new team / company and primary contact</Typography>
                    </Grid>
                    <Grid item>
                        <Button onClick={handleAddTeamPrimaryClick}
                        color='primary'
                        variant='contained'
                        >
                            Add Team and Primary page
                        </Button>
                    </Grid>
                </Grid>
                <Grid item container direction='column' spacing={2}>
                    <Grid item>
                        <Typography className={classes.sectionHeader}>Add new features for Popup</Typography>
                    </Grid>
                    <Grid item>
                        <Typography>Add all new features added to the portal which will be shown to users when they login (depending on their preference)</Typography>
                    </Grid>
                    <Grid item>
                        <Button onClick={handleAddNewFeaturesClick}
                        color='primary'
                        variant='contained'
                        >
                            Add New Features
                        </Button>
                    </Grid>
                </Grid>
                <Grid item container direction='column' spacing={2}>
                    <Grid item>
                        <Typography className={classes.sectionHeader}>Order Files</Typography>
                    </Grid>
                    <Grid item>
                        <Typography>View / download / upload order related files</Typography>
                    </Grid>
                    <Grid item>
                        <Button onClick={handleFileUploadClick}
                        color='primary'
                        variant='contained'
                        >
                            File Upload
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container className={classes.root} direction='column' spacing={7}>
              <Grid item>
                <Typography className={classes.pageHeader}>
                  Current Admins
                </Typography>
              </Grid>
              <Grid item>
                {listAllAdmins()}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        </>
    );
}
